export default __webpack_public_path__ + "static/media/iconCloseLightBlue.a7d04f09.svg";